// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../areIntervalsOverlapping/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var areIntervalsOverlappingWithOptions = convertToFP(fn, 3);
export default areIntervalsOverlappingWithOptions;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/areIntervalsOverlappingWithOptions/index.js
// module id = 821
// module chunks = 0